/**
 * Thin HTTP client for system-api `/sequence` (request 0228 / spec 0010 fase A).
 */

import { systemApiFetch } from '@/services/systemApiClient'

const SEQUENCE_MOUNT = {
  basePath: '/sequence/v1',
  /** Preserve the original missing-host wording from the first 0228 client. */
  hostErrorPath: '/sequence',
} as const

export type NextCodeParams = {
  entity: string
  field: string
  usePoint?: string
}

/**
 * Allocate the next integer code for `(org, entity, field)`.
 * `entity` must be the PascalCase registry name (e.g. `ProductionOrder`).
 */
export async function nextCode(orgId: string, params: NextCodeParams): Promise<number> {
  const result = await systemApiFetch<{ next: number }>(SEQUENCE_MOUNT, '/next', {
    method: 'POST',
    orgId,
    body: JSON.stringify(params),
  })
  return result.next
}
